(() => {
  if (window.madamInstaSmoothScroll) return;
  window.madamInstaSmoothScroll = true;

  document.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaX) < 1) return;

    const feed = event.target.closest('#insta-feed');
    if (!feed) return;

    const candidates = [
      feed,
      ...feed.querySelectorAll('*')
    ];

    const gallery = candidates.find((element) => {
      const style = window.getComputedStyle(element);

      return (
        element.scrollWidth > element.clientWidth + 20 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden'
      );
    });

    if (!gallery) return;

    const maxScroll =
      gallery.scrollWidth - gallery.clientWidth;

    const nextScroll = Math.max(
      0,
      Math.min(
        maxScroll,
        gallery.scrollLeft + event.deltaX
      )
    );

    if (nextScroll === gallery.scrollLeft) return;

    gallery.scrollLeft = nextScroll;
    event.preventDefault();

  }, { passive: false });
})();